import { images } from '@/asset';
import BoldLargeText from '@/components/BoldLargeText';
import RegularText from '@/components/RegularText';
import { IProps, RuleTypeEnum } from '@/pages/Onboarding';
import { Badge } from '@shopify/polaris';
import { useMemo } from 'react';

const Step2 = (props: IProps) => {
  const { ruleType: currentType, setRuleType, handleNext } = props;
  const ruleTypes = useMemo(() => {
    return [
      {
        id: 1,
        badgeTone: 'success',
        badgeContent: 'Shopline Plus',
        title: 'Dynamic delivery dates in Checkout',
        description: 'Show during Checkout, on Thank You, Order Status page',
        imgSrc: images.chooseCheckoutRule,
        onclick: () => {
          setRuleType?.(RuleTypeEnum.Checkout);
          handleNext?.();
        },
        type: RuleTypeEnum.Checkout,
      },
      {
        id: 2,
        badgeTone: undefined,
        badgeContent: 'Any stores',
        title: 'Delivery dates on storefront pages',
        description: 'Display on product, collection, main store pages',
        imgSrc: images.chooseSFRule,
        onclick: () => {
          setRuleType?.(RuleTypeEnum.Storefront);
          handleNext?.();
        },
        type: RuleTypeEnum.Storefront,
      },
    ];
  }, [setRuleType, handleNext]);

  return (
    <div className="step-2">
      <div className="d-flex flex-column gap-12 items-center mt-16">
        <BoldLargeText alignment="center">Choose how to display delivery dates to your customers</BoldLargeText>
        <RegularText alignment="center">Just start with one way. You can set up both ways later in app</RegularText>
      </div>

      <div className="d-flex gap-16 mt-32">
        {ruleTypes.map((ruleType) => (
          <div
            className={`d-flex gap-8 flex-column items-center w-full cursor-pointer content-between button-select-type ${
              currentType === ruleType.type || (!currentType && ruleType.type === RuleTypeEnum.Storefront) ? 'selected' : ''
            }`}
            key={ruleType.id}
            onClick={ruleType.onclick}
          >
            <div className="d-flex gap-8 flex-column items-center mb-16 p-16">
              <div className="content-center">
                <Badge tone={ruleType.badgeTone as any}>{ruleType.badgeContent}</Badge>
              </div>
              <p className="button-title">{ruleType.title}</p>
              <RegularText alignment="center">{ruleType.description}</RegularText>
            </div>
            <img src={ruleType.imgSrc} alt="img" style={{ width: '100%', objectFit: 'cover' }} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Step2;
